import { isInitialReachoutStatus } from "@features/PricingProject/lib/whatsappReachoutStatus";
import { WhatsappReachoutStatusBadge } from "@features/PricingProject/ui/WhatsappReachoutStatusBadge";
import { WhatsappReachoutStatus } from "@shared/lib/types/briefInfluencerV2";
import { Button, Dropdown } from "@shared/ui";
import { MoreOutlined } from "@ant-design/icons";
import styles from "./styles.module.scss";

interface PricingReachoutCellProps {
  status?: WhatsappReachoutStatus;
  failedReason?: string;
  deeplinkUrl?: string;
  onReachout?: (isResend: boolean) => void;
}

export function PricingReachoutCell({
  status,
  failedReason,
  deeplinkUrl,
  onReachout,
}: PricingReachoutCellProps) {
  const isResend = !isInitialReachoutStatus(status);
  const showAction =
    onReachout && status !== WhatsappReachoutStatus.Processing;

  const reachoutMenuItems = [
    {
      key: isResend ? "resend-reachout" : "send-reachout",
      label: isResend ? "Resend Reachout" : "Send Reachout",
    },
  ];

  return (
    <div className={styles.reachoutCell}>
      <WhatsappReachoutStatusBadge
        status={status}
        failedReason={failedReason}
        deeplinkUrl={deeplinkUrl}
      />
      {showAction ? (
        <Dropdown
          trigger={["click"]}
          placement="bottomRight"
          menu={{
            items: reachoutMenuItems,
            onClick: ({ domEvent }) => {
              domEvent.stopPropagation();
              onReachout?.(isResend);
            },
          }}
        >
          <Button
            type="text"
            size="small"
            className={styles.reachoutActionsBtn}
            icon={<MoreOutlined />}
            onClick={(event) => event.stopPropagation()}
          />
        </Dropdown>
      ) : null}
    </div>
  );
}
